import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { toRefs } from 'vue'
import VueQrcode from '@chenfengyuan/vue-qrcode';

interface Props {
  text: string;
  size: number;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    text: null,
    size: null
  },
  setup(__props: any) {

const props = __props as {
  text: string;
  size: number;
}



const { text, size } = toRefs(props);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueQrcode), {
    value: _unref(text),
    options: { width: _unref(size) }
  }, null, 8, ["value", "options"]))
}
}

})